import type { AnalyticsEvent } from '../../services/analytics';

export const DEFAULT_EVENT_ID = 'login';

const FALLBACK: AnalyticsEvent[] = [{ id: DEFAULT_EVENT_ID, label: 'Acesso' }];

/** Textos dos eventos fixos, como no prototipo (vale mesmo se o back-end mandar outro rotulo). */
const LABELS: Record<string, string> = {
    login: 'Acesso',
    lancamento: 'Receita ou despesa lançada',
    analise: 'Análise financeira visualizada',
};

/** Opcoes do seletor; sem a lista do back-end, so Acesso. */
export function eventOptions(events: AnalyticsEvent[] | undefined): AnalyticsEvent[] {
    if (!events || events.length === 0) return FALLBACK;
    return events.map((e) => ({ id: e.id, label: LABELS[e.id] ?? e.label }));
}
